import { Fragment, type ReactNode } from "react";
import { messageText, useLocale } from "./locale";

/** Named slots let translations reorder values and links without parsing HTML. */
export function Message({ message, values = {} }: {
  message: string;
  values?: Record<string, ReactNode>;
}) {
  useLocale();
  return <>{messageText(message).split(/(\{\{\w+\}\})/g).map((part, index) => {
    const key = /^\{\{(\w+)\}\}$/.exec(part)?.[1];
    return <Fragment key={index}>{key && Object.prototype.hasOwnProperty.call(values, key) ? values[key] : part}</Fragment>;
  })}</>;
}
